<template>
	<v-select
		:value="value"
		:items="hotels"
		:loading="loading"
		:readonly="readonly"
		:disabled="disabled"
		:required="required"
		:solo="solo"
		prepend-icon="domain"
		@input="onInput"
		@change="onChange"
		item-text="name"
		item-value="code"
		:label="label"
	>
		<!-- @input="$emit('input')" -->
	</v-select>
</template>

<script>

export default {
	props: {
		label: {
			type: String,
			default: 'Отель'
		},
		value: String,
		hotels: Array,
		solo: Boolean,
		readonly: Boolean,
		disabled: Boolean,
		required: Boolean,
		loading: Boolean
	},
	data: () => ({

	}),
	methods: {
		onChange(e) {
			this.$store.dispatch('setSelectedHotelCode', e)
			this.$emit('change', e)
		},
		onInput(e) {
			this.$emit('input', e)
		}
	}
}

</script>
